var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "id_9 clear" }, [
    _c("div", { staticClass: "img_box" }, [
      _c(
        "video",
        {
          ref: "video",
          attrs: {
            controlslist: "nodownload",
            controls: "",
            src: _vm.data.src
          },
          on: {
            contextmenu: function($event) {
              $event.preventDefault()
              return _vm.contextmenu.apply(null, arguments)
            }
          }
        },
        [_vm._v("\n      " + _vm._s(_vm.$t("flowActive15")) + "\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-80237cac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-80237cac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/course/public/id_9.vue
// module id = null
// module chunks = 